import React from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

export default function CartItem() {
    return (
        <Box width={1} mx={'auto'}>
            <Grid container>
                <Grid size={10}>
                    <Grid container height={1}>
                        <Grid size={5}>
                            <Box height={140} width={130} bgcolor={'#DBDAD9'}>
                                {
                                    <Box />
                                }
                            </Box>
                        </Grid>
                        <Grid size={7} height={1}>
                            <Box height={'80%'}>
                                <Typography variant="h4" color='text.secondary' fontSize={'1.5rem'}>Skin Cushion</Typography>
                                <Typography variant="h4" marginTop={'6px'} color='text.secondary' fontSize={'1.125rem'}>120 €</Typography>
                            </Box>
                            <Box height={'20%'}>
                                <Box height={1} display={'flex'} width={'72px'} justifyContent={'space-between'} sx={{ border: 'solid 1px #DBDAD9', borderRadius: '19px' }} paddingX={'20px'}>
                                    <Typography variant="body1" fontSize={'1.125rem'} color='text.secondary' sx={{ cursor: 'pointer' }}>-</Typography>
                                    <Typography variant="body1" fontSize={'1.125rem'} color='text.secondary'>1</Typography>
                                    <Typography variant="body1" fontSize={'1.125rem'} color='text.secondary' sx={{ cursor: 'pointer' }}>+</Typography>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={2}>
                    <Box display={'flex'} alignItems={'flex-end'} height={1}>
                        <Typography variant="body1" sx={{ textDecoration: 'underline', color: '#707070', cursor: 'pointer' }}>remove</Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}